const createOrUpdateUserSSCDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
      failure_response {
        res_status
        response
      }
    `;

  const successFields = `
      completion_percentage
    `;

  const mutation = `create_or_update_user_ssc_details(user_ssc_details_input: $user_ssc_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation) {
    return {
      mutation: `
      mutation CreateOrUpdateUserSSCDetails($user_ssc_details_input: UserSSCDetailsInput!) {
        ${mutation}
      }
    `,
      type: 'CreateOrUpdateUserSSCDetailsMutationResponse!'
    };
  } else return { mutation, type: 'UserSSCDetailsInput!' };
};

export { createOrUpdateUserSSCDetailsGraphQlMutation };
